<ng-container [ngSwitch]="currentStage">
  <div class="bl-overflow--none">
    <dx-prefill
      class="bl-display--block bl-border-radius"
      [(instaTouchState)]="stage"
      [autofillField]="field"
      [isLoading]="isLoading"
      [errorMessage]="errorMessage"
      [showCodeSentAlert]="showCodeSentAlert"
      [mobileNumber]="mobileNumber"
      (getPassCode)="getPassCode($event)"
      (resendPassCode)="resendPassCode($event)"
      (validatePassCode)="validatePassCode($event)"
      (getPersonalInfo)="getPersonalInfo($event)"
      (proceedWithoutPhone)="proceedWithoutPhonePrefill($event)"
    >
    </dx-prefill>
  </div>
</ng-container>
